const RECEIVE_ADBUSINESSUNITS = 'src/adPlatforms/RECEIVE_ADBUSINESSUNITS';
const CLEAR_ADBUSINESSUNITS = 'src/adPlatforms/CLEAR_ADBUSINESSUNITS';

export default {
  CLEAR_ADBUSINESSUNITS,
  RECEIVE_ADBUSINESSUNITS
};
